import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiProvider } from "@src/store/ApiProvider";
import axios from "axios";
import { withPasswordManagerRefresh } from "./passwordManagerRequest";

interface IUpdateNotificationEmailParams {
	credentialId: number;
	email: string;
}

interface IUpdateNotificationEmailState {
	loading: boolean;
	error: string | null;
}

const initialState: IUpdateNotificationEmailState = {
	loading: false,
	error: null,
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

const buildUrl = (credentialId: number, email: string) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	const encodedEmail = encodeURIComponent(email);
	return `${baseUrl.replace(/\/$/, "")}/Credentials/UpdateNotificationMail?credentialId=${credentialId}&email=${encodedEmail}`;
};

export const updateNotificationEmail = createAsyncThunk<undefined, IUpdateNotificationEmailParams>(
	"passwordManager/updateNotificationEmail",
	async ({ credentialId, email }, { rejectWithValue, dispatch }) => {
		try {
			await withPasswordManagerRefresh(dispatch, () =>
				axios.put(buildUrl(credentialId, email), undefined, { headers: getAuthHeaders() }),
			);
			return undefined;
		} catch (error: unknown) {
			return rejectWithValue(error instanceof Error ? error.message : "Failed to update notification email");
		}
	},
);

const updateNotificationEmailSlice = createSlice({
	name: "passwordManager/updateNotificationEmail",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(updateNotificationEmail.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(updateNotificationEmail.fulfilled, (state) => {
				state.loading = false;
				state.error = null;
			})
			.addCase(updateNotificationEmail.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) || action.error.message || "Failed to update notification email";
			});
	},
});

export const updateNotificationEmailReducer = updateNotificationEmailSlice.reducer;
